/**
 * @generated SignedSource<<01dc4badf51ded237a3112b2de4d04ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ThreadType = "WELLBEING" | "WORK";
import { FragmentRefs } from "relay-runtime";
export type CompanionSessionCard_thread$data = {
  readonly createdAt: string;
  readonly id: string;
  readonly summary: {
    readonly body: string;
    readonly title: string;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly type: ThreadType;
  readonly " $fragmentType": "CompanionSessionCard_thread";
};
export type CompanionSessionCard_thread$key = {
  readonly " $data"?: CompanionSessionCard_thread$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanionSessionCard_thread">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanionSessionCard_thread",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ThreadSummary",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Thread",
  "abstractKey": null
};
})();

(node as any).hash = "90383dd1c90f4ee4013e2248f4aef27b";

export default node;
